import React from "react";
import Profile from "@/components/Pages/Dashboard/Profile";

const ProfilePage: React.FC = () => {
  return <Profile />;
};

export default ProfilePage;
